module.exports = __webpack_public_path__ + "img/incorrect.b7ca3afd.png";